import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import MainLayout from "../../layout";
import queryString from "query-string";
import Loader from "../../assets/icons/loader/loader";
import DeleteModal from "../../components/modal/delete-modal";
import AdminFilterDrawer from "../../components/filter/admin-filter-drawer";
import { api } from "../../redux/apis/api";
import { useRole } from "../../context/role/RoleContext";
import Pagination from "../../components/pagination";
import menuIcon from "../../assets/icons/more-fill.svg";
import { useRef } from "react";

const ListLead = () => {
  const location = useLocation();
  const { state } = useRole();
  const permission = state?.role?.lead;
  const queryParamsData = new URLSearchParams(location.search);
  const page_no = parseInt(queryParamsData.get("page") ?? 1);

  const [data, setData] = useState({
    rows: [],
    page: 1,
    count: 0,
  });
  const [loading, setLoading] = useState(true);
  const [filterDrawerOpen, setFilterDrawerOpen] = useState(false);
  const [deleteModalShow, setdeleteModalShow] = useState(false);
  const [selectDelete, setSelectDelete] = useState("");
  const [stateList, setstateList] = useState([]);
  const [citiesList, setCitiesList] = useState([]);
  const [userList, setuserList] = useState([]);

  const fetchData = () => {
    const rawFilters = queryString.parse(location.search, {
      arrayFormat: "bracket",
    });

    const filters = normalizeParsedParams(rawFilters);

    setLoading(true);
    api
      .post(`/lead/list`, {
        page: page_no,
        ...filters,
      })
      .then((res) => {
        setData(res.data.data);
        setLoading(false);
      })
      .catch((err) => {
        console.error("API Error:", err);
        setLoading(false);
      });
  };

  function normalizeParsedParams(parsed) {
    const result = {};

    for (const [key, value] of Object.entries(parsed)) {
      const match = key.match(/^(\w+)\[(\w+)\]$/);
      if (match) {
        const [, parent, child] = match;
        if (!result[parent]) result[parent] = {};
        result[parent][child] = value;
      } else {
        result[key] = value;
      }
    }

    return result;
  }

  useEffect(() => {
    fetchData();
  }, [page_no, location.search]);

  const deleteFnc = (id) => {
    api
      .post(`/lead/delete`, {
        id: id,
      })
      .then((res) => {
        setData(res.data.data);
        setLoading(false);
        fetchData();
      })
      .catch((err) => {
        console.error("API Error:", err);
        setLoading(false);
      });
  };

  const fetchStateDropDownData = () => {
    api
      .post(`/settings/state-dropdown`)
      .then((res) => {
        let newArr = res?.data?.data?.states?.map((ele) => ({
          label: ele.name,
          value: ele.id,
        }));
        setstateList(newArr);
      })
      .catch((err) => {
        console.error("API Error:", err);
      });
  };

  const fetchCityDropDownData = () => {
    api
      .post(`/settings/city-dropdown`)
      .then((res) => {
        let newArr = res?.data?.data?.cities?.map((ele) => ({
          label: ele.name,
          value: ele.id,
        }));
        setCitiesList(newArr);
      })
      .catch((err) => {
        console.error("API Error:", err);
      });
  };

  const fetchUserDropDownData = () => {
    api
      .get(`/ffadmin/user-list-dropdown`)
      .then((res) => {
        let newArr = res?.data?.data?.users?.map((ele) => ({
          label: ele.name,
          value: ele.id,
        }));
        setuserList(newArr);
      })
      .catch((err) => {
        console.error("API Error:", err);
      });
  };

  useEffect(() => {
    if (filterDrawerOpen) {
      fetchStateDropDownData();
      fetchCityDropDownData();
      fetchUserDropDownData();
    }
  }, [filterDrawerOpen]);

  const filterInputs = [
    {
      label: "Name",
      type: "text",
      name: "name",
    },
    {
      label: "state",
      type: "dropdown",
      name: "state",
      options: stateList,
    },
    {
      label: "city",
      type: "dropdown",
      name: "city",
      options: citiesList,
    },
    {
      label: "created by",
      type: "dropdown",
      name: "created_by",
      options: userList,
    },
    {
      label: "customer type",
      type: "dropdown",
      name: "customer_type",
      options: [
        {
          label: "Individual",
          value: "individual",
        },
        {
          label: "Shop",
          value: "shop",
        },
        {
          label: "Distributor",
          value: "distributor",
        },
        {
          label: "Tile layer",
          value: "tile_layer",
        },
        {
          label: "Contractor",
          value: "contractor",
        },
        {
          label: "Industry",
          value: "industry",
        },
      ],
    },
    {
      label: "status",
      type: "dropdown",
      name: "status",
      options: [
        {
          label: "new",
          value: "new",
        },
        {
          label: "existing",
          value: "existing",
        },
        {
          label: "interested",
          value: "interested",
        },
        {
          label: "converted",
          value: "converted",
        },
        {
          label: "needs time",
          value: "needs time",
        },
        {
          label: "contacting",
          value: "contacting",
        },
        {
          label: "lost",
          value: "lost",
        },
        {
          label: "issue packaging",
          value: "issue packaging",
        },
      ],
    },
    {
      label: "Type Of Billing",
      type: "dropdown",
      name: "TypeOfBilling",
      options: [
        {
          label: "half",
          value: "half",
        },
        {
          label: "full",
          value: "full",
        },
        {
          label: "none",
          value: "none",
        },
      ],
    },
    {
      label: "Type Of Client",
      type: "dropdown",
      name: "TypeOfClient",
      options: [
        {
          label: "existing",
          value: "existing",
        },
        {
          label: "new",
          value: "new",
        },
        {
          label: "not interested",
          value: "not interested",
        },
      ],
    },
    {
      label: "last visited",
      type: "date",
      name: "last_visited",
    },
    {
      label: "last called",
      type: "date",
      name: "last_called",
    },
    {
      label: "next visit on",
      type: "date",
      name: "next_visit_on",
    },
    {
      label: "next call on",
      type: "date",
      name: "next_call_on",
    },
    {
      label: "created At",
      type: "date",
      name: "createdAt",
    },
    {
      label: "updated At",
      type: "date",
      name: "updatedAt",
    },
  ];

  const searchParams = new URLSearchParams(location.search);
  searchParams.delete("page");
  const filters = searchParams.toString() ? `&${searchParams.toString()}` : "";

  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [selectedIndex, setselectedIndex] = useState(null);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };

    if (dropdownOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [dropdownOpen]);

  const tableName = "lead";

  const writePermission = (row) => {
    if (row?.assignedTo) {
      if (row?.assignedTo.write == true) {
        return true;
      }
      return false;
    }
    if (permission?.write == true) {
      return true;
    }
  };

  return (
    <MainLayout>
      <DeleteModal
        isOpen={deleteModalShow}
        onClose={() => {
          setdeleteModalShow(false);
          setSelectDelete("");
        }}
        btnFnc={() => deleteFnc(selectDelete)}
      />
      <section className="h-full">
        <div className="flex justify-between items-center mb-5">
          <h2 className="text-fs_14 md:text-fs_16 font-semibold capitalize">
            lead List
          </h2>
          <div className="flex gap-2 relative">
            <AdminFilterDrawer
              filterInputs={filterInputs}
              open={filterDrawerOpen}
              onClose={() => setFilterDrawerOpen(false)}
              queryParamsData={queryParamsData}
            />
            {permission?.write && (
              <Link
                className="md:px-4 md:py-2 px-2 py-1 text-fs_14 bg-blue-600 text-white rounded"
                to={`/lead/create`}
              >
                Create
              </Link>
            )}
            <button
              onClick={() => setFilterDrawerOpen(true)}
              className="md:px-4 md:py-2 px-2 py-1 text-fs_14 bg-secondary text-white rounded"
            >
              Filters
            </button>
          </div>
        </div>
        <section className="h-[calc(100%-3.5rem)] flex flex-col justify-between overflow-auto">
          <div className="w-full lg:max-w-[82.2vw]  overflow-auto h-full">
            <div className="relative overflow-x-auto">
              <table className="w-full text-left rtl:text-right border border-gray-200 text-nowrap">
                <thead className="text-gray-700 uppercase bg-white">
                  <tr>
                    <th
                      scope="col"
                      className="px-4 py-3 capitalize text-fs_16 font-fw_600"
                    >
                      id
                    </th>
                    <th
                      scope="col"
                      className="px-4 py-3 capitalize text-fs_16 font-fw_600"
                    >
                      Name
                    </th>
                    <th
                      scope="col"
                      className="px-4 py-3 capitalize text-fs_16 font-fw_600"
                    >
                      contact name
                    </th>
                    <th
                      scope="col"
                      className="px-4 py-3 capitalize text-fs_16 font-fw_600"
                    >
                      contact number
                    </th>
                    <th
                      scope="col"
                      className="px-4 py-3 capitalize text-fs_16 font-fw_600"
                    >
                      type of client
                    </th>
                    <th
                      scope="col"
                      className="px-4 py-3 capitalize text-fs_16 font-fw_600"
                    >
                      State
                    </th>
                    <th
                      scope="col"
                      className="px-4 py-3 capitalize text-fs_16 font-fw_600"
                    >
                      City
                    </th>

                    <th
                      scope="col"
                      className="px-4 py-3 capitalize text-fs_16 font-fw_600 sticky right-0 z-10 bg-white"
                    >
                      Actions
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {loading ? (
                    <tr>
                      <td rowSpan={1}>
                        <div className="w-full flex justify-center py-5">
                          <div className="h-[100px] w-[100px]">
                            <Loader />
                          </div>
                        </div>
                      </td>
                    </tr>
                  ) : (
                    <>
                      {data.rows?.length ? (
                        <>
                          {data.rows.map((row, index) => {
                            return (
                              <tr key={index} className="border-t bg-white">
                                <td className="p-1 px-2">{row?.id ?? "--"}</td>
                                <td className="px-4 py-2 max-w-[350px]">
                                  <span className="truncate overflow-hidden whitespace-nowrap block">
                                    {row?.name ?? "--"}
                                  </span>
                                </td>
                                <td className="px-4 py-2 max-w-[350px]">
                                  <span className="truncate overflow-hidden whitespace-nowrap block">
                                    {row?.contact_name ?? "--"}
                                  </span>
                                </td>
                                <td className="px-4 py-2 max-w-[350px]">
                                  <span className="truncate overflow-hidden whitespace-nowrap block">
                                    {row?.contact_number ?? "--"}
                                  </span>
                                </td>
                                <td className="px-4 py-2 max-w-[350px]">
                                  <span className="truncate overflow-hidden whitespace-nowrap block">
                                    {row?.type_of_client ?? "--"}
                                  </span>
                                </td>
                                <td className="px-4 py-2 max-w-[350px]">
                                  <span className="truncate overflow-hidden whitespace-nowrap block">
                                    {row?.state?.name ?? "--"}
                                  </span>
                                </td>
                                <td className="px-4 py-2 max-w-[350px]">
                                  <span className="truncate overflow-hidden whitespace-nowrap block">
                                    {row?.city?.name ?? "--"}
                                  </span>
                                </td>

                                <td className="py-2 sticky right-0 z-10 bg-white">
                                  <div className="hidden sm:block">
                                    <div className="flex gap-3 bg-white px-4">
                                      <Link
                                        to={`/${tableName}/view/${row["id"]}?activeTab=lead`}
                                        className="text-secondary border-[1px] border-secondary px-3 py-1 rounded-md text-fs_14 hover:bg-green-50"
                                      >
                                        View
                                      </Link>
                                      {writePermission(row) && (
                                        <Link
                                          to={`/${tableName}/edit/${row["id"]}`}
                                          className="text-primary border-[1px] border-primary px-3 py-1 rounded-md text-fs_14 hover:bg-blue-50"
                                        >
                                          Edit
                                        </Link>
                                      )}
                                      {writePermission(row) && (
                                        <button
                                          onClick={() => {
                                            setdeleteModalShow(true);
                                            setSelectDelete(row["id"]);
                                          }}
                                          className="text-errorColor border-[1px] border-errorColor px-3 py-1 rounded-md text-fs_14 hover:bg-red-50"
                                        >
                                          Delete
                                        </button>
                                      )}
                                    </div>
                                  </div>

                                  <div
                                    onClick={() => setselectedIndex(index)}
                                    className="sm:hidden flex justify-center items-center relative"
                                  >
                                    <div className="relative">
                                      <img
                                        src={menuIcon}
                                        alt=":"
                                        width={18}
                                        height={18}
                                        onClick={() =>
                                          setDropdownOpen(!dropdownOpen)
                                        }
                                        className="cursor-pointer"
                                      />

                                      {selectedIndex === index &&
                                        dropdownOpen && (
                                          <div
                                            ref={dropdownRef}
                                            className="absolute top-[-0.8rem] right-6 bg-white shadow-md rounded-md flex gap-2 p-1  z-[55505050505055] border min-w-[8rem]"
                                          >
                                            <Link
                                              to={`/${tableName}/view/${row["id"]}?activeTab=lead`}
                                              className="text-secondary border-[1px] border-secondary px-3 py-0 rounded-md text-fs_14 hover:bg-green-50"
                                            >
                                              View
                                            </Link>
                                            {writePermission(row) && (
                                              <Link
                                                to={`/${tableName}/edit/${row["id"]}`}
                                                className="text-primary border-[1px] border-primary px-3 py-0 rounded-md text-fs_14 hover:bg-blue-50"
                                              >
                                                Edit
                                              </Link>
                                            )}
                                            {writePermission(row) && (
                                              <button
                                                onClick={() => {
                                                  setdeleteModalShow(true);
                                                  setSelectDelete(row["id"]);
                                                }}
                                                className="text-errorColor border-[1px] border-errorColor px-3 py-0 rounded-md text-fs_14 hover:bg-red-50"
                                              >
                                                Delete
                                              </button>
                                            )}
                                          </div>
                                        )}
                                    </div>
                                  </div>
                                </td>
                              </tr>
                            );
                          })}
                        </>
                      ) : (
                        <tr>
                          <td>
                            <p className="text-center my-5">No data found</p>
                          </td>
                        </tr>
                      )}
                    </>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </section>
      </section>
      <div
        className={`${
          loading === true ? "pointer-events-none opacity-45" : ""
        }`}
      >
        <Pagination
          totalPages={parseInt(data?.count) ?? 0}
          pagination={parseInt(data?.page) ?? 0}
          path={`/lead/list`}
          filters={filters}
        />
      </div>
    </MainLayout>
  );
};

export default ListLead;
